import { React } from 'react';

function SectionTitle(props) {
    return (
        <>
        <div className="section-title text-center">
            <h6>{props.subtitle}</h6>
            <h2>{props.title}</h2>
            <p>{props.titleContent}</p>
        </div>
        </>
    )
}

export default SectionTitle;